import { ProductUid, RelatedProductType, RelatedsStyleVariation } from '../../domain/models/related-products.models';

import { CartItem } from '@api/cart/cart.models';
import { MediasPublicModels } from '@features/products/medias';
import { ProductPublicModels } from '@features/products/product';
import { ProductViewPlace } from '@shared/product/models';

export interface RelatedProductTypeConfig {
    name: RelatedProductType;
    maxItems: number;
    campaign?: string;
    excluded?: RelatedProductExcludedConfig;
}

export interface RelatedProductExcludedConfig {
    typeOfProduct: string | null;
    subFamilyIds: string[];
}

export interface RelatedProductsCarousel {
    currentPage: number;
    filteredItemsIds: ProductUid[];
    id: string;
    isLoadingProducts: boolean;
    itemsIds: ProductUid[];
    productsLoaded: Record<string, string>;
    productsViewed: number;
    relatedTypes: RelatedProductTypeConfig[];
    titleKey: string;
    view: RelatedsStyleVariation;
    excluded?: RelatedProductExcludedConfig;
    imageType?: MediasPublicModels.PublicMediaClazzType;
}

export interface RelatedsPlace {
    baseProducts: Array<ProductPublicModels.PublicProduct | CartItem>;
    carousels: Record<string, RelatedProductsCarousel>;
    excludedProducts: ProductPublicModels.PublicProduct[];
}

export interface RelatedProductsState {
    places: Record<ProductViewPlace, RelatedsPlace>;
}

export const relatedProductsInitialState: RelatedProductsState = {
    places: undefined,
};

export interface SetRelatedsCarouselsForPlaceSuccessProps {
    placeName: ProductViewPlace;
    relatedPlace: Record<string, Partial<RelatedProductsCarousel>>;
    excludedProducts: ProductPublicModels.PublicProduct[];
    baseProducts: Array<ProductPublicModels.PublicProduct | CartItem>;
    section: string;
}
